import React from 'react';
import { motion } from 'framer-motion';
import styles from './PageHero.module.css';

/**
 * Reusable hero for sub-pages.
 * Photo background, dark overlay, eyebrow + display headline + lede.
 */
export default function PageHero({ eyebrow, title, lede, image }) {
  return (
    <section className={styles.hero}>
      <div className={styles.photoWrap}>
        <img src={image} alt="" className={styles.photo} />
      </div>
      <div className={styles.overlay} />

      <div className={styles.content}>
        <h1 className={styles.title}>
          {title.map((line, i) => (
            <span key={i} className={styles.titleLine}>
              <motion.span
                className={styles.titleInner}
                initial={{ y: '108%' }}
                animate={{ y: '0%' }}
                transition={{ duration: 1.1, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        {lede && (
          <motion.p
            className={styles.lede}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
          >
            {lede}
          </motion.p>
        )}
      </div>
    </section>
  );
}
